/**
 * Single-metaphor trailing hint on hub primary strip (decorative).
 * Folder: open / expand in tree. Project: monitor = open workspace.
 */

function svgBase(className) {
    return {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 22,
        height: 22,
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 1.65,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        className,
        'aria-hidden': true,
        focusable: false,
    };
}

/** Folder + arrow right — expand / open in browse tree */
function TrailFolderOpenIcon({ className = '' }) {
    return (
        <svg {...svgBase(className)}>
            <path d="M3 7a2 2 0 0 1 2-2h3.5l1.5 2H19a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" />
            <path d="m13.5 12 4 3-4 3" />
            <path d="M17.5 15H11" />
        </svg>
    );
}

/** Monitor — open project workspace on screen */
function TrailMonitorIcon({ className = '' }) {
    return (
        <svg {...svgBase(className)}>
            <rect x="3" y="4" width="14" height="10" rx="1.5" />
            <path d="M7 18h6" />
            <path d="M10 14v4" />
        </svg>
    );
}

/**
 * @param {'folder'|'project'} props.variant
 */
export default function HubRowPrimaryTrailIcon({ variant, className = '' }) {
    if (variant === 'project') {
        return <TrailMonitorIcon className={className} />;
    }
    return <TrailFolderOpenIcon className={className} />;
}
